import MeetingRoomBooking from './MeetingRoomBooking';

export default MeetingRoomBooking;
